import React, { FC, useContext } from 'react';
import classNames from 'classnames';
import ModalBox, {
	Container as ModalContainer,
	Content as ModalContent,
	ContentCloak,
	Footer as ModalFooter,
	Header as ModalHeader,
} from 'components/ModalBox';
import Button from '../../../../../../ReactSharedScripts/components/Button';
import { isNullOrUndefined } from '../../../../../../ReactSharedScripts/predicates/type';
import { FlexGrid } from '../../../../../../ReactSharedScripts/components/FlexGrid';
import { TranslationContext } from '../../../../../../ReactSharedScripts/modules/translations';
import { red } from '../../../../../../ReactSharedScripts/components/Color';
import { codes } from '../../../../../../ReactSharedScripts/data/translations';
import { ConfirmationModalProps } from '../../../../../../ReactSharedScripts/components/ModalBox/layouts/ConfirmationModal/types';
import { ErrorBoundary } from '../../../../../../ReactSharedScripts/components/ErrorBoundary';
import classes from './styles/index.module.scss';
import { ExclamationCircleO } from '../../../../../../ReactSharedScripts/components/Icons/ExclamationCircleO';

export const ConfirmationModal: FC<ConfirmationModalProps> = ({
	danger,
	header,
	isOpen,
	onClose,
	content,
	primary,
	onExited,
	isPending,
	onConfirm,
	confirmButtonBlock,
	hideConfirmButton,
	cancelButtonText,
	onConfirmAndSave,
	confirmButtonText,
	hideCancelButton,
	showNotificationIcon,
	saveAndConfirmButtonText,
	dataTestId = 'confirmationModal',
	buttonSize = 'small',
}) => {
	const { translate } = useContext(TranslationContext);

	const btnGroupClasses = classNames(classes.btnGroup, {
		[classes.btnGroup_singleBtn]: hideConfirmButton || hideCancelButton,
	});

	return (
		<ModalBox
			onClose={onClose}
			open={isOpen}
			size='tiny'
			onExited={onExited}
			hasFullScreen={false}
			render={(modalRenderData) => {
				return (
					<ModalContainer dataTestId={dataTestId}>
						<ModalHeader
							{...modalRenderData}
							title={header}
						/>
						<ModalContent className={classes.modalContainer}>
							{isPending && <ContentCloak />}
							<ErrorBoundary>
								<FlexGrid
									column
									center
									gap='small'
									className={classes.confirmationContent}
								>
									{showNotificationIcon && (
										<ExclamationCircleO
											color={red[7]}
											width={32}
											height={32}
										/>
									)}
									{!isNullOrUndefined(content) && content}
								</FlexGrid>
							</ErrorBoundary>
						</ModalContent>
						<ModalFooter>
							<div className={btnGroupClasses}>
								{onConfirmAndSave && (
									<Button
										disabled={isPending}
										onClick={onConfirmAndSave}
										primary
										dataTestId='confirmationModal__saveAndConfirm'
										size={buttonSize}
									>
										{saveAndConfirmButtonText || translate(codes.common.save)}
									</Button>
								)}
								{!hideConfirmButton && (
									<Button
										disabled={isPending}
										onClick={onConfirm}
										primary={primary}
										danger={danger}
										block={confirmButtonBlock}
										dataTestId='confirmationModal__confirm'
										size={buttonSize}
									>
										{confirmButtonText || translate(codes.ok)}
									</Button>
								)}
								{!hideCancelButton && (
									<Button
										onClick={onClose}
										link
										dataTestId='confirmationModal__cancel'
										size={buttonSize}
									>
										{cancelButtonText || translate(codes.common.cancel)}
									</Button>
								)}
							</div>
						</ModalFooter>
					</ModalContainer>
				);
			}}
		/>
	);
};

ConfirmationModal.defaultProps = {
	header: '',
	onClose: () => {},
	isPending: false,
	hideCancelButton: false,
	showNotificationIcon: true,
};
